import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiPartnerConsolesCompaniesAnalyticsMeetingNotesIndexResponseType,
  ApiPartnerConsolesCompaniesAnalyticsMeetingNotesIndexRequestType,
} from "~/domains";

type RequestDataType = {
  companyId: string;
  params?: ApiPartnerConsolesCompaniesAnalyticsMeetingNotesIndexRequestType;
};

const request = async ({
  params,
  companyId,
}: RequestDataType): Promise<ApiPartnerConsolesCompaniesAnalyticsMeetingNotesIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiPartnerConsolesCompaniesAnalyticsMeetingNotesIndexResponseType>(
      `/api/partner_consoles/companies/${companyId}/analytics/meeting_notes`,
      params,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiPartnerConsolesCompaniesAnalyticsMeetingNotesIndexRequestType;
  companyId: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisPartnerConsolesCompaniesAnalyticsMeetingNotesIndex = ({
  params,
  companyId,
  config = {},
}: PropsType): UseQueryResult<ApiPartnerConsolesCompaniesAnalyticsMeetingNotesIndexResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [
      "ApisPartnerConsolesCompaniesAnalyticsMeetingNotesIndex",
      companyId,
      params,
    ],
    queryFn: () => request({ companyId, params }),
  });
};
